import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type MessageHistoryStore = {
  messageHistory: string[]

  addMessageToHistory: (message: string) => void
}

export const useMessageHistoryStore = create<MessageHistoryStore>()(
  devtools(
    persist(
      (set) => ({
        messageHistory: [],
        addMessageToHistory: (message) =>
          set((state) => ({
            ...state,
            messageHistory: [message, ...(state.messageHistory ?? []).slice(0, 100).filter(String)],
          })),
      }),
      {
        name: 'botpress-message-history', // Dynamically set the store name
      }
    )
  )
)
